// Allowlist for `returnUrl` query param / `VITE_DEFAULT_APP_URL`.
// Anything else is dropped to prevent the "Back to app" button from being
// turned into an open redirect by a crafted link.
//
// Allowed:
//   https://<anything>.sirktek.com[/...]
//   https://ledger17.com[/...]
//   https://<anything>.ledger17.com[/...]
//   https://vardly.no[/...]
//   https://<anything>.vardly.no[/...]
//   https://saldo17.no[/...]
//   https://<anything>.saldo17.no[/...]
//   https://reinventar.no[/...]
//   https://<anything>.reinventar.no[/...]

const isSirktekSubdomain = (host: string) => host.endsWith('.sirktek.com');
const isLedger17 = (host: string) =>
    host === 'ledger17.com' || host.endsWith('.ledger17.com');
const isVardly = (host: string) =>
    host === 'vardly.no' || host.endsWith('.vardly.no');
// Saldo17's own domain, not a ledger17 subdomain: its companion app is app.saldo17.no,
// which the saldo17 profile's appLinkUrl points at.
const isSaldo17 = (host: string) =>
    host === 'saldo17.no' || host.endsWith('.saldo17.no');
// Reinventar's own domain: app.reinventar.no is the companion app the profile's
// appLinkUrl points at, admin./test-admin. this orgadmin instance.
const isReinventar = (host: string) =>
    host === 'reinventar.no' || host.endsWith('.reinventar.no');

export const isAllowedReturnUrl = (url: string | null | undefined): boolean => {
    if (!url) return false;
    let parsed: URL;
    try {
        parsed = new URL(url);
    } catch {
        return false;
    }
    if (parsed.protocol !== 'https:') return false;
    const host = parsed.hostname.toLowerCase();
    return (
        isSirktekSubdomain(host) ||
        isLedger17(host) ||
        isVardly(host) ||
        isSaldo17(host) ||
        isReinventar(host)
    );
};
